module.exports = __webpack_public_path__ + "9b1073051ebf95c1afcbf8230ce3b7bb.png";